import {
  MessageIcon,
  NotificationIcon,
  SearchIcon
} from "../../../../utils/MyIcons";

import usePageName from '../../../../hooks/ui-hooks/usePageName';

const AdminTopBar = () => {

  const currentPageName = usePageName("admin");


  return (
    <div className="bg-white-cream w-100 ">
      <div className="container admin-topbar pt-4 pb-4 sticky-top  d-flex justify-content-between align-items-center">
        <span className="fs-1 fw-900 text-title ">{currentPageName}</span>
        <div className="d-flex align-items-center gap-2 ">
          <div className=" search border border-1 rounded-3 d-flex align-items-center">
            <span className="ps-3">
              <SearchIcon />
            </span>
            <input
              type="text"
              className="rounded-3 p-2 w-min-250px border-0 bg-transparent "
              placeholder="Search"
              aria-label="Search"
            />
          </div>

          <button className="d-flex align-items-center justify-content-center w-h-44px rounded-circle border bg-transparent">
            <MessageIcon />
          </button>
          <button className="d-flex align-items-center justify-content-center w-h-44px rounded-circle border bg-transparent">
            <NotificationIcon />
          </button>
        </div>
      </div>
    </div>
  );
};
export default AdminTopBar;
